/** How many prior years the fallback options include alongside the current year. */
const FALLBACK_PRIOR_YEARS = 3;

/**
 * Turns the reinsurance years a table holds (from the API's `Get…ReinsuranceYears`
 * endpoints) into dropdown options: de-duplicated, newest first, so the first
 * option is the latest year.
 *
 * Falls back to the current year plus the 3 prior years when there is nothing
 * to go on (the table is empty or the years couldn't be loaded), so the screen
 * still offers a selection.
 */
export function toYearOptions(years: readonly number[] | null | undefined): number[] {
  const distinct = [...new Set((years ?? []).filter((y) => Number.isInteger(y)))];
  if (distinct.length) {
    return distinct.sort((a, b) => b - a);
  }
  const current = new Date().getFullYear();
  const fallback: number[] = [];
  for (let y = current; y >= current - FALLBACK_PRIOR_YEARS; y--) {
    fallback.push(y);
  }
  return fallback;
}
